import { debounce } from 'data/function';
import { DeskControllerBase } from '../DeskControllerBase';
import { FilterTypes } from '../FilterTypes';
import { ActiveMessageSegmentEventsConstants } from 'modules/application/detail/attendance/AttendanceSegmentEvents';
import './ActiveMessage.scss';
import { ActiveMessageConstants } from './ActiveMessageConstants';
import { BlipToastDuration } from 'modules/shared/BlipToastService';
export class ActiveMessageDeskController extends DeskControllerBase {
    static $inject = ['application', 'DeskConfigurationService', 'LoadingService', '$scope', 'SegmentService', '$rootScope', 'ActiveMessageDeskSharedService', '$timeout', '$translate', 'BlipToastService'];
    constructor(application, DeskConfigurationService, LoadingService, $scope, SegmentService, $rootScope, ActiveMessageDeskSharedService, $timeout, $translate, BlipToastService) {
        'ngInject';
        super(application, LoadingService, DeskConfigurationService, $scope);
        this.application = application;
        this.DeskConfigurationService = DeskConfigurationService;
        this.LoadingService = LoadingService;
        this.$scope = $scope;
        this.SegmentService = SegmentService;
        this.$rootScope = $rootScope;
        this.ActiveMessageDeskSharedService = ActiveMessageDeskSharedService;
        this.$timeout = $timeout;
        this.$translate = $translate;
        this.BlipToastService = BlipToastService;
        this.hasInvalidReturnFlow = undefined;
        this.isUpdatingReturnFlow = false;
        this.searchTemplateName = (event) => {
            this.filterTemplateName = event.detail.value;
            this.filterTemplateListByName(this.filterTemplateName);
            this.notFound = (this.approvedMessageTemplatesWithParams.length == 0);
            this.notFoundWithFilter = false;
            if (this.notFound) {
                this.notFound = false;
                this.notFoundWithFilter = true;
            }
            this.createFilterTrack(FilterTypes.TemplateName);
            this.$timeout(this.$scope.$apply());
        };
        this.selectReturnFlowFilter = (event) => {
            const selectedValue = event.detail?.value;
            this.returnFlowSelected = selectedValue || '';
        };
        this.selectStatusFilter = (event) => {
            const selectedValue = event.detail?.value;
            this.statusSelected = selectedValue || '';
        };
        this.selectEditReturnFlowValue = (messageTemplateWithParams) => {
            const hasSavedStateId = !!messageTemplateWithParams.params.stateId;
            if (!hasSavedStateId && !messageTemplateWithParams.params.editingState) {
                return undefined;
            }
            const value = messageTemplateWithParams.params.isValid && hasSavedStateId
                ? messageTemplateWithParams.params.stateId
                : this.singleReturnFlow
                    ? this.singleReturnFlow.value.id
                    : undefined;
            return value;
        };
        this.selectEditReturnFlow = (event) => {
            if (!this.hoverCurrentParams.params) {
                this.hoverCurrentParams.params = {};
            }
            this.hoverCurrentParams.params.editingState = event.detail?.value;
        };
        this.selectUpdateReturnFlow = (event) => {
            this.updateReturnFlowValue = event.detail?.value;
        };
        this.toggleMessageTemplateWithParams = async (event) => {
            this.startLoading();
            await this.saveMessageTemplateWithParams(event.detail.checked);
            this.stopLoading();
        };
        this.toggleTemplateMessageModal = async () => {
            this.openDetailModal = !this.openDetailModal;
            if (this.openDetailModal) {
                const model = await this.$translate('templateMessage.table.modal.model');
                this.modalTitle = `${model} "${this.hoverCurrentParams.template.Name}"`;
                this.modalBody = this.getMessageFromTemplate(this.hoverCurrentParams.template, true);
                this.SegmentService.createApplicationTrack({
                    trackEvent: ActiveMessageSegmentEventsConstants.MESSAGE_TEMPLATE_SHOW,
                    application: this.application,
                    payload: {
                        templateType: this.getTemplateType(this.hoverCurrentParams.template),
                    },
                });
            }
        };
        this.toggleStateIdUpdateModal = async () => {
            this.openStateIdUpdate = !this.openStateIdUpdate;
            if (this.openStateIdUpdate) {
                this.updateReturnFlowValue = this.singleReturnFlow ? this.singleReturnFlow.value.id : '';
                this.modalTitle = await this.$translate('templateMessage.table.modal.updateStateTitle');
            }
        };
        this.dropDownOpened = () => {
            this.isDropDownOpened = true;
            this.editingParams = this.hoverCurrentParams;
        };
        this.dropDownClosed = () => {
            this.isDropDownOpened = false;
            this.editingParams = undefined;
        };
        this.getTemplateType = (template) => {
            const headerComponent = template.Components.filter(c => c.Type.toUpperCase() == 'HEADER');
            if (headerComponent?.length == 1) {
                const format = headerComponent[0].Format;
                if (format) {
                    return format.toLowerCase();
                }
                return 'text';
            }
            return '';
        };
        this.dropdownDirection = (template) => {
            const rowIndex = this.approvedMessageTemplatesWithParams.indexOf(template);
            if (this.approvedMessageTemplatesWithParams.length > 11 &&
                rowIndex > this.approvedMessageTemplatesWithParams.length - 4) {
                return 'top';
            }
            return 'bottom';
        };
        this.debouncedSearch = debounce(this.searchTemplateName, 500);
    }
    async $onInit() {
        this.displayReturnFlow = '';
        this.returnFlowSelected = '';
        this.returnFlowCollection = [];
        this.filteredReturnFlowNames = [];
        this.displayStatus = '';
        this.statusSelected = '';
        this.statusCollection = [];
        this.statusConstantCollection = [];
        this.filteredStatus = [];
        this.filterTemplateName = '';
        this.autoCompleteElementList = [];
        this.lastSearch = new Map();
        this.notFound = false;
        this.notFoundWithFilter = false;
        this.editReturnFlow = [];
        this.openDetailModal = false;
        this.openStateIdUpdate = false;
        this.isDropDownOpened = false;
        this.hoverCurrentParams = undefined;
        this.editingParams = undefined;
        this.isUpdatingReturnFlow = false;
        this.startLoading();
        await Promise.all([
            this.getReturnFlow(),
            this.getStatus(),
        ]);
        this.initializeAndBindAutocompleteList();
        await this.query();
        this.stopLoading();
        this.SegmentService.createApplicationTrack({
            trackEvent: ActiveMessageSegmentEventsConstants.MESSAGE_TEMPLATE_OPENED,
            application: this.application,
        });
    }
    async query() {
        const filters = this.getFilters();
        const messageTemplateWithParams = await this.ActiveMessageDeskSharedService.get(filters);
        this.approvedMessageTemplatesWithParams = messageTemplateWithParams?.resource?.items ?? [];
        this.approvedMessageTemplatesWithParams = this.approvedMessageTemplatesWithParams.map((state) => ({
            params: {
                isValid: this.isValidFlowState(state.params),
                editingState: this.singleReturnFlow ? this.singleReturnFlow.value.id : '',
                ...state.params,
            },
            template: state.template,
        }));
        this.hasInvalidReturnFlow = this.approvedMessageTemplatesWithParams.find((msgTemplate) => !msgTemplate.params.isValid);
        this.approvedMessageTemplatesWithParamsCache = this.approvedMessageTemplatesWithParams;
        this.filterTemplateListByName(this.filterTemplateName);
        this.notFound = (this.approvedMessageTemplatesWithParams.length == 0);
        this.notFoundWithFilter = false;
        if (this.notFound && filters) {
            this.notFound = false;
            this.notFoundWithFilter = true;
        }
    }
    getFilters() {
        const filter = [];
        if (this.filteredReturnFlowNames.length > 0) {
            filter.push(`stateId=${this.filteredReturnFlowNames.map((state) => state.item.value.id).join(',')}`);
        }
        if (this.filteredStatus.length === 1) {
            const enabled = this.filteredStatus[0].item.value.toUpperCase() === 'HABILITADO';
            filter.push(`enabled=${enabled}`);
        }
        if (this.filterTemplateName) {
            filter.push('templateNameFrontOnly=true');
        }
        return filter.join('&');
    }
    initializeAndBindAutocompleteList() {
        this.autoCompleteElementList = [
            {
                id: '#bdsAutocomplete_returnFlow_filter',
                options: this.returnFlowCollection,
            },
            {
                id: '#bdsAutocomplete_status_filter',
                options: this.statusCollection,
            },
        ];
        this.autoCompleteElementList.forEach((autoComplete) => {
            this.bindAutocomplete(autoComplete.id);
            this.lastSearch.set(autoComplete.id.replace('#', ''), {});
        });
    }
    bindAutocomplete(id, options) {
        const autoComplete = this.autoCompleteElementList.find((autocompleteElement) => autocompleteElement.id === id);
        const element = autoComplete?.element ?? document.querySelector(autoComplete.id);
        element.options = options || JSON.stringify(autoComplete.options);
        autoComplete.element = element;
    }
    clearAutocompleteElements() {
        this.autoCompleteElementList.forEach((autoComplete) => {
            if (autoComplete.element) {
                autoComplete.element.value = undefined;
            }
        });
    }
    getStatus() {
        const status = ['Habilitado', 'Desabilitado'];
        this.statusCollection = status.map((statusType) => ({
            text: statusType,
            value: statusType,
            label: statusType,
        }));
        this.statusConstantCollection = this.statusCollection;
    }
    async getReturnFlow() {
        const returnFlow = await this.ActiveMessageDeskSharedService.getReturnFlow();
        this.returnFlowConstantCollection = returnFlow?.resource?.states?.items ?? [];
        this.returnFlowConstantCollection = this.returnFlowConstantCollection.map((state) => ({
            text: state.name,
            value: state,
            label: state.name,
        }));
        this.editReturnFlow = this.returnFlowConstantCollection.map((state) => ({
            text: state.text,
            value: state.value.id,
            label: state.text,
        }));
        this.returnFlowCollection = this.returnFlowConstantCollection;
        this.singleReturnFlow = this.returnFlowConstantCollection.length === 1 ? this.returnFlowConstantCollection[0] : undefined;
    }
    startLoading() {
        if (!this.LoadingService.isLoadingGlobal() || !this.LoadingService.isLoadingLocal()) {
            this.LoadingService.startLoading();
        }
    }
    stopLoading() {
        if (this.LoadingService.isLoadingGlobal() || this.LoadingService.isLoadingLocal()) {
            this.LoadingService.stopLoading();
        }
    }
    filterTemplateListByName(namePart) {
        if (namePart) {
            this.approvedMessageTemplatesWithParams = this.approvedMessageTemplatesWithParamsCache.filter(params => params.template.Name.indexOf(namePart) > -1);
        }
        else {
            this.approvedMessageTemplatesWithParams = this.approvedMessageTemplatesWithParamsCache;
        }
    }
    createFilterTrack(filteredBy) {
        if (FilterTypes.ReturnFlowName === filteredBy) {
            this.SegmentService.createApplicationTrack({
                trackEvent: ActiveMessageSegmentEventsConstants.MESSAGE_TEMPLATE_FILTER_RETURN_FLOW,
                application: this.application,
            });
        }
        if (FilterTypes.Status === filteredBy) {
            this.SegmentService.createApplicationTrack({
                trackEvent: ActiveMessageSegmentEventsConstants.MESSAGE_TEMPLATE_FILTER_STATUS,
                application: this.application,
            });
        }
        if (FilterTypes.TemplateName === filteredBy) {
            this.SegmentService.createApplicationTrack({
                trackEvent: ActiveMessageSegmentEventsConstants.MESSAGE_TEMPLATE_SEARCH,
                application: this.application,
            });
        }
    }
    clearFilterInput() {
        this.$rootScope.$broadcast('ToggleDropdownItem');
        this.clearAutocompleteElements();
    }
    async addReturnFlowFilterClearInput() {
        this.createFilterTrack(FilterTypes.ReturnFlowName);
        this.addReturnFlowFilter(this.returnFlowSelected);
        this.clearFilterInput();
        await this.reload();
    }
    async addStatusFilterClearInput() {
        this.createFilterTrack(FilterTypes.Status);
        this.addStatusFilter(this.statusSelected);
        this.clearFilterInput();
        await this.reload();
    }
    addReturnFlowFilter(item) {
        if (!item) {
            return;
        }
        const removedItem = this.returnFlowCollection.find((returnFlow) => returnFlow.value.id == item.id);
        this.returnFlowCollection = this.returnFlowCollection.filter((returnFlow) => returnFlow.value.id !== this.returnFlowSelected.id);
        this.filteredReturnFlowNames = this.filteredReturnFlowNames.concat({
            text: removedItem.text,
            item: removedItem,
        });
        this.bindAutocomplete('#bdsAutocomplete_returnFlow_filter', JSON.stringify(this.returnFlowCollection));
    }
    addStatusFilter(item) {
        if (!item) {
            return;
        }
        const removedItem = this.statusCollection.find((status) => status.value == item);
        this.statusCollection = this.statusCollection.filter((status) => status.value !== item);
        this.filteredStatus = this.filteredStatus.concat({
            text: removedItem.text,
            item: removedItem,
        });
        this.bindAutocomplete('#bdsAutocomplete_status_filter', JSON.stringify(this.statusCollection));
    }
    async removeReturnFlowName(items, removedItem) {
        this.returnFlowCollection = this.returnFlowCollection.concat(removedItem.item);
        this.filteredReturnFlowNames = items;
        await this.reload();
        this.bindAutocomplete('#bdsAutocomplete_returnFlow_filter', JSON.stringify(this.returnFlowCollection));
    }
    async removeStatus(items, removedItem) {
        this.statusCollection = this.statusCollection.concat(removedItem.item);
        this.filteredStatus = items;
        await this.reload();
        this.bindAutocomplete('#bdsAutocomplete_status_filter', JSON.stringify(this.statusCollection));
    }
    async clearAllFilters() {
        this.filterTemplateName = '';
        this.filteredReturnFlowNames = [];
        this.filteredStatus = [];
        this.returnFlowCollection = this.returnFlowConstantCollection;
        this.statusCollection = this.statusConstantCollection;
        this.initializeAndBindAutocompleteList();
        this.notFound = false;
        this.notFoundWithFilter = false;
        await this.reload();
    }
    async reload() {
        this.startLoading();
        await this.query();
        this.stopLoading();
    }
    getMessageFromTemplate(template, addStyles = false) {
        if (!template) {
            return '';
        }
        const header = template.Components.find((component) => component.Type === 'HEADER');
        const body = template.Components.find((component) => component.Type === 'BODY');
        const footer = template.Components.find((component) => component.Type === 'FOOTER');
        const message = [header?.Text, body?.Text, footer?.Text];
        const styleMessage = this.formatText(message.filter((messagePart) => messagePart)
            .join(ActiveMessageConstants.NEW_LINE)
            .replace(/\\n/g, ActiveMessageConstants.NEW_LINE), addStyles);
        return styleMessage;
    }
    formatText(text, addStyles) {
        if (!text) {
            return '';
        }
        text = text.replace(/<[^>]+>/gm, '');
        if (addStyles) {
            text = text.replace(/\*([^*]+)\*/g, '<strong>$1</strong>');
            text = text.replace(/\_([^*]+)\_/g, '<span class="text-italic">$1</span>');
            text = text.replace(/\~([^*]+)\~/g, '<span class="text-line-through">$1</span>');
            text = text.replace(/\{\{\d+\}\}/g, '<span class="text-italic text-blue">$&</span>');
        }
        else {
            text = text.replace(/\*([^*]+)\*/g, '$1');
            text = text.replace(/\_([^*]+)\_/g, '$1');
            text = text.replace(/\~([^*]+)\~/g, '$1');
        }
        return text;
    }
    getFlowStateName(messageTemplateParams) {
        if (!messageTemplateParams || !messageTemplateParams.stateId) {
            if (this.singleReturnFlow) {
                return this.singleReturnFlow.value.name;
            }
            return '';
        }
        const flowState = this.returnFlowConstantCollection.find((state) => state.value?.id === messageTemplateParams.stateId);
        return flowState ? flowState.value.name : '';
    }
    clearEditInput(messageTemplateWithParams) {
        const elementId = `#bdsAutocomplete_edit_form_return_flow_${messageTemplateWithParams.template.Id}`;
        const element = document.querySelector(elementId);
        element.value = undefined;
        this.$rootScope.$broadcast('ToggleDropdownItem');
        if (messageTemplateWithParams.params) {
            messageTemplateWithParams.params.editingState = undefined;
            if (this.singleReturnFlow) {
                messageTemplateWithParams.params.editingState = this.singleReturnFlow.value.id;
            }
        }
        this.editingParams = undefined;
        this.isDropDownOpened = false;
    }
    async applyReturnFlowEdit(messageTemplateWithParams) {
        this.startLoading();
        if (!this.hoverCurrentParams.params) {
            this.hoverCurrentParams.params = {
                isEnabled: false,
            };
        }
        messageTemplateWithParams.params.templateId = messageTemplateWithParams.params.templateId ?? this.hoverCurrentParams.template.Id;
        messageTemplateWithParams.params.stateId = messageTemplateWithParams.params.editingState;
        messageTemplateWithParams.params.isValid = this.isValidFlowState(messageTemplateWithParams.params);
        this.SegmentService.createApplicationTrack({
            trackEvent: ActiveMessageSegmentEventsConstants.MESSAGE_TEMPLATE_EDIT_SETTINGS,
            application: this.application,
            payload: {
                templateType: this.getTemplateType(this.hoverCurrentParams.template),
            },
        });
        await this.ActiveMessageDeskSharedService.save(messageTemplateWithParams.params);
        this.clearEditInput(messageTemplateWithParams);
        this.stopLoading();
        await this.reload();
    }
    isValidFlowState(messageTemplateParams) {
        if (!messageTemplateParams || !messageTemplateParams.stateId) {
            return true;
        }
        const flowState = this.returnFlowConstantCollection.find((state) => state.value?.id === messageTemplateParams.stateId);
        return flowState !== undefined;
    }
    async saveMessageTemplateWithParams(checked) {
        if (!this.hoverCurrentParams.params.stateId) {
            this.hoverCurrentParams.params = {
                stateId: this.singleReturnFlow ? this.singleReturnFlow.value.id : '',
                templateId: this.hoverCurrentParams.template.Id,
            };
        }
        this.hoverCurrentParams.params.isEnabled = checked;
        this.SegmentService.createApplicationTrack({
            trackEvent: checked ? ActiveMessageSegmentEventsConstants.MESSAGE_TEMPLATE_ON : ActiveMessageSegmentEventsConstants.MESSAGE_TEMPLATE_OFF,
            application: this.application,
            payload: {
                templateType: this.getTemplateType(this.hoverCurrentParams.template),
            },
        });
        await this.ActiveMessageDeskSharedService.save(this.hoverCurrentParams.params);
    }
    isEnabled(approvedMessageTemplatesWithParams) {
        return approvedMessageTemplatesWithParams.params !== undefined &&
            approvedMessageTemplatesWithParams.params.isEnabled;
    }
    isDropDownEditButtonEnabled(approvedMessageTemplatesWithParams) {
        const hasParams = !!approvedMessageTemplatesWithParams.params;
        const isEditing = hasParams && !!approvedMessageTemplatesWithParams.params.editingState;
        return hasParams && isEditing;
    }
    canShowEditButton(templateId) {
        return this.isDropDownOpened ?
            this.editingParams?.template?.Id === templateId :
            this.hoverCurrentParams?.template?.Id === templateId;
    }
    async messageTemplateUpdateStateId() {
        if (this.isUpdatingReturnFlow) {
            return;
        }
        this.startLoading();
        this.SegmentService.createApplicationTrack({
            trackEvent: ActiveMessageSegmentEventsConstants.MESSAGE_TEMPLATE_UPDATE_INVALID_STATEID,
            application: this.application,
        });
        this.isUpdatingReturnFlow = true;
        try {
            const invalidMessageTemplates = this.approvedMessageTemplatesWithParamsCache.filter((msgTemplate) => !msgTemplate.params.isValid);
            invalidMessageTemplates.forEach(async (msgTemplate) => await this.updateSingleMessageTemplate(msgTemplate));
            this.BlipToastService.show('success', {
                msg: await this.$translate('templateMessage.table.modal.updateSuccess'),
            });
        }
        catch (e) {
            this.SegmentService.createApplicationTrack({
                trackEvent: ActiveMessageSegmentEventsConstants.MESSAGE_TEMPLATE_UPDATE_INVALID_STATEID_ERROR,
                application: this.application,
            });
            console.log(e);
            this.BlipToastService.show('danger', {
                title: await this.$translate('templateMessage.table.modal.error.title'),
                msg: await this.$translate('templateMessage.table.modal.error.description'),
                duration: BlipToastDuration.WITH_TITLE.NO_ACTION,
            });
        }
        this.stopLoading();
        await this.reload();
        this.isUpdatingReturnFlow = false;
        this.openStateIdUpdate = false;
    }
    async updateSingleMessageTemplate(msgTemplate) {
        msgTemplate.params.stateId = this.updateReturnFlowValue;
        this.hoverCurrentParams = msgTemplate;
        await this.saveMessageTemplateWithParams(msgTemplate.params.isEnabled);
    }
}
ActiveMessageDeskController.$inject = ['application', 'DeskConfigurationService', 'LoadingService', '$scope', 'SegmentService', '$rootScope', 'ActiveMessageDeskSharedService', '$timeout', '$translate', 'BlipToastService'];
